import script from "./DemandAssignModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DemandAssignModal.vue?vue&type=script&setup=true&lang=js"

import "./DemandAssignModal.vue?vue&type=style&index=0&id=70d2dcad&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70d2dcad"]])

export default __exports__